import { OrganizationRoles } from '~/constants/organizations'
import { AppRoles } from '~/constants/user'

export const isSignUpDisabled = () => {
  const appConfig = useAppConfig()
  return appConfig.disableSignUp ?? false
}

export const currentUserCanCreateOrganization = () => {
  const appConfig = useAppConfig()
  return Number(appConfig.minimumRoleToCreateOrganization)
    ? isCurrentUserGrantedInApp(appConfig.minimumRoleToCreateOrganization)
    : isCurrentUserGrantedInApp(AppRoles.User)
}

export const currentUserCanCreateWorkspace = () => {
  const appConfig = useAppConfig()
  return isCurrentUserGrantedInOrganization(appConfig.minimumRoleToCreateWorkspace ?? OrganizationRoles.User)
}

// TODO: Rename for explicit naming because it is related to organizations & members roles
export const getFormattedAppConfigMenuItems = async (key: 'app' | 'organization' | 'user') => {
  const appConfig = useAppConfig()
  const hasMenuItems = Object.hasOwnProperty.call(appConfig, 'menuItems')
    && Object.hasOwnProperty.call(appConfig.menuItems, key)

  if (hasMenuItems) {
    return Object.entries(appConfig.menuItems[key]).map(([organizationRole, menuItems]) => {
      if (!isCurrentUserGrantedInOrganization(organizationRole)) return []

      return menuItems.map((menuItem) => {
        const shadowMenuItem = { ...menuItem }
        if (key === 'organization' && shadowMenuItem.to) {
          shadowMenuItem.to = getOrganizationRoutePath(shadowMenuItem.to)
        }
        if (
          (key === 'app' || key === 'organization')
          && shadowMenuItem.items
        ) {
          shadowMenuItem.items = shadowMenuItem.items.map(item => ({
            ...item,
            ...(item.to && { to: getOrganizationRoutePath(item.to) }),
          }))
        }
        return shadowMenuItem
      })
    }).flat()
  }
  else {
    return []
  }
}

export const getAppConfigAdminMenuItems = () => {
  const appConfig = useAppConfig()
  return appConfig.menuItems?.admin?.() ?? []
}
